import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import useTypedFlags from "hooks/useTypedFlags";
import { AccountContext } from "views/AccountWrapper";
import { AwsIntegration, AzureIntegration } from "types/generated";
import { hasSpaceManageAccess } from "utils/user";
import { hasManageAccess } from "utils/access";

type CloudIntegration = AwsIntegration | AzureIntegration;

const useCanManageCloudIntegration = (): ((integration: CloudIntegration) => boolean) => {
  const { viewer } = useTypedContext(AccountContext);
  const { customAccessRoles } = useTypedFlags();

  return useCallback(
    (integration: CloudIntegration) => {
      if (viewer.admin) {
        return true;
      }

      if (customAccessRoles) {
        return hasManageAccess(viewer, integration.spaceDetails.id);
      }

      return hasSpaceManageAccess(integration.spaceDetails.accessLevel);
    },
    [customAccessRoles, viewer]
  );
};

export default useCanManageCloudIntegration;
